import React, { useContext } from 'react';
import Signup from '../../composed/signup/Signup';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import SideContentOne from '../../composed/sidecontent/SideContent-One';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';

const SignupPage = () => {
  const { onPhoneVerifyResponse } = useContext(GlobalStateDataContext);
  const { signupAPIResponse } = useContext(SignUpDataContext);
  const { data, loading, message, success } = signupAPIResponse;

  const isOtpVerified = !!(
    onPhoneVerifyResponse?.data?.data?.success &&
    onPhoneVerifyResponse?.data?.data?.CustomMessage === 'OTP Verified'
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        height: 'calc(100vh auto)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 'auto' }}>
        {(!(success && message === 'Successfully created new kitchen') || isOtpVerified) && (
          <div style={{ marginRight: '10px' }}>
            <SideContentOne />
          </div>
        )}

        <div style={{ marginLeft: '10px', marginTop: '20px', marginBottom: '20px' }}>
          <Signup />
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
